import { Subject } from 'rxjs';
import { CoordinatorService } from './coordinator.service';
import { Table } from './table';
import { TableInstance } from './table-instance';
import { TemplateTag } from './template$';
import { TEMPL } from './template-repository$';

// export type RowGeneratorParams = {
//     title: string
//     cellLs: TCPAR[]
// }

export type CTIPAR = {
    origin: any;
    templateId: TemplateTag;
    forceNew?: boolean;
    templateModification?: {
        id: string;
        fun: (templ: TEMPL) => TEMPL;
    };
    isEditMode?: boolean;
};

export class Table$ {
    // refresh$ = new Subject<void>()

    private _tableMap = new Map<string, Table>();

    private _instanceMap = new Map<string, TableInstance>();

    constructor(private coords: CoordinatorService) {}

    createTableInstance(params: any) {
        let tblId = params.templateId;
        let instId = `${params.origin.id}|${params.templateId}`;
        if (params.templateModification) {
            instId += `|${params.templateModification.id}`;
            tblId += `|${params.templateModification.id}`;
        }
        let tbli = this._instanceMap.get(instId);
        if (!tbli || params.forceNew) {
            let tbl = this._tableMap.get(tblId);
            if (!tbl) {
                let templ = <TEMPL>this.coords.template$.get(params.templateId);
                if (params.templateModification) templ = params.templateModification.fun(templ);
                tbl = new Table(this.coords, templ);
                this._tableMap.set(tblId, tbl);
            }

            tbli = tbl.instance(params.origin);
            this._instanceMap.set(instId, tbli);
        }
        if (params.isEditMode) tbli.isEditOn = true;
        return tbli;
    }

    // getTemplateTable(template, origin) {
    //     // console.log(222, template)
    //     let tbl = this._tableMap.get(template.id)
    //     if (tbl)
    //         return tbl.instance(origin)

    //     tbl = new Table(this.coords, template)
    //     this._tableMap.set(tbl.id, tbl)
    //     return tbl.instance(origin)
    // }

    get(tblId: string) {
        return this._tableMap.get(tblId);
    }
}
